import { render, staticRenderFns } from "./SearchUser.vue?vue&type=template&id=639c1d56&scoped=true&"
import script from "./searchUser.ts?vue&type=script&lang=ts&"
export * from "./searchUser.ts?vue&type=script&lang=ts&"
import style0 from "./SearchUser.vue?vue&type=style&index=0&id=639c1d56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639c1d56",
  null
  
)

export default component.exports